function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import utils from './utils';
var Danmaku = function () {
    function Danmaku(options, player) {
        var _this = this;
        _classCallCheck(this, Danmaku);
        _defineProperty(this, 'checkShield', function (dan) {
            var type = typeof dan.type === 'number' ? utils.number2Type(dan.type) : dan.type;
            var origin = dan.origin;
            if ((_this[''.concat(type, 'Limit')] || _this[''.concat(origin, 'Limit')]) && !/(\/n)|(\\n)/i.test(dan.text)) {
                return false;
            }
            if (_this.repeatLimit) {
                var danIndex = _this.dan.indexOf(dan);
                var restDan = _toConsumableArray(_this.dan);
                restDan.splice(danIndex, 1);
                var danText = restDan.map(function (dan) {
                    return dan.text;
                });
                if (danText.includes(dan.text)) {
                    return false;
                }
            }
            return true;
        });
        this.player = player;
        this.options = options;
        this.createHash = utils.initHash();
        this.tunnelPadding = 4;
        this.container = this.options.container;
        this.danTunnel = {
            right: {},
            left: {},
            top: {},
            bottom: {}
        };
        this.tunnelHeights = {
            right: [],
            left: [],
            top: [],
            bottom: []
        };
        this.danCount = {
            unknown: 0,
            mfuns: 0,
            bili: 0,
            acfun: 0
        };
        this.danData = {
            unknown: null,
            mfuns: null,
            bili: null,
            acfun: null
        };
        this.danIndex = 0;
        this.drawIndex = 0;
        this.dan = [];
        this.currentDan = [];
        this.showing = this.options.isShow;
        this._opacity = this.options.opacity;
        this._fontScale = this.options.fontScale;
        this._speed = this.options.speed;
        this._limitArea = this.options.limitArea;
        this._isFullscreen = this.options.isFullscreen;
        this.events = this.options.events;
        this.topLimit = false;
        this.bottomLimit = false;
        this.leftLimit = false;
        this.rightLimit = false;
        this.colorLimit = false;
        this.repeatLimit = false;
        this.advanceLimit = false;
        this.mfunsLimit = false;
        this.biliLimit = false;
        this.acfunLimit = false;
        this.unknownLimit = false;
        this.unlimited = this.options.unlimited;
        this.originFilter = new Set();
        this.loaded = false;
        this.paused = true;
        this.danmakuCheck = false;
        this.danmakuTip = this.player.template.danmakuTip;
        this.danmakuTimer = null;
        this.danmakuTipBox = this.player.template.danmakuTipBox;
        this.currentX = 0;
        this.currentY = 0;
        this._measure('');
        this.load();
        this.initDanmakuTips();
        this.showing ? this.show() : this.hide();
    }
    _createClass(Danmaku, [
        {
            key: 'initDanmakuTips',
            value: function initDanmakuTips() {
                var _this2 = this;
                var danmakuTip = function danmakuTip(e) {
                    _this2.currentX = e.pageX;
                    _this2.currentY = e.pageY;
                    var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
                    var scrollY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    var items = _this2.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    if (e.target !== _this2.player.template.danmakuReport && e.target !== _this2.player.template.danmakuCopy && !_this2.player.controller.isLocked) {
                        _this2.danmakuTip.classList.remove('show');
                        _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                    } else {
                        return;
                    }
                    var _loop = function _loop() {
                        var item = items[i];
                        var boundingClientRect = item.getBoundingClientRect();
                        var danLeft = boundingClientRect.left + scrollX;
                        var danRight = boundingClientRect.right + scrollX;
                        var danTop = boundingClientRect.top + scrollY;
                        var danBottom = boundingClientRect.bottom + scrollY;
                        clearTimeout(_this2.danmakuTimer);
                        _this2.danmakuTimer = null;
                        if (danLeft < e.pageX && e.pageX < danRight && danTop < e.pageY && e.pageY < danBottom) {
                            _this2.currentLockDanmaku = item;
                            _this2.lockDanmakuData = _this2.getDanmakuData(item.dataset.id);
                            item.classList.add('lock');
                            _this2.danmakuTip.classList.add('show');
                            var tipWidth = _this2.danmakuTip.querySelector('.mfunsPlayer-danmaku-item-tip-box').offsetWidth;
                            var tipHeight = _this2.danmakuTip.querySelector('.mfunsPlayer-danmaku-item-tip-box').offsetHeight;
                            var itemTop = danTop - _this2.container.getBoundingClientRect().top - scrollY;
                            _this2.danmakuTip.style.top = itemTop + 5 + 'px';
                            _this2.danmakuTip.style.height = tipHeight + 5 + item.offsetHeight + 'px';
                            if (e.pageX - _this2.container.getBoundingClientRect().left < tipWidth / 2) {
                                _this2.danmakuTip.style.left = -scrollX;
                            } else if (_this2.container.clientWidth - (e.pageX - _this2.container.getBoundingClientRect().left) < tipWidth / 2) {
                                _this2.danmakuTip.style.left = 'auto';
                                _this2.danmakuTip.style.right = -scrollX;
                            } else {
                                _this2.danmakuTip.style.left = e.pageX - _this2.container.getBoundingClientRect().left - tipWidth / 2 - scrollX + 'px';
                            }
                            _this2.danmakuTimer = setTimeout(function () {
                                _this2.danmakuTip.classList.remove('show');
                                item.classList.remove('lock');
                                _this2.currentLockDanmaku = null;
                            }, 3000);
                            return 'break';
                        } else {
                            item.classList.remove('lock');
                            _this2.currentLockDanmaku = null;
                        }
                    };
                    for (var i = 0; i < items.length; i++) {
                        var _ret = _loop();
                        if (_ret === 'break')
                            break;
                    }
                };
                this.player.template.gesture.addEventListener('click', danmakuTip);
                this.player.template.danmakuCopy.addEventListener('click', function (e) {
                    console.log('复制');
                    if (_this2.player.controller.clickFlag > 1)
                        return;
                    if (navigator.clipboard) {
                        navigator.clipboard.writeText(_this2.lockDanmakuData.text).then(function (res) {
                            _this2.player.notice('已复制');
                        })['catch'](function (err) {
                            console.log(err);
                        });
                    } else {
                        _this2.player.events.trigger('danmaku_copy', _this2.lockDanmakuData.text);
                    }
                    _this2.danmakuTip.classList.remove('show');
                    _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                });
                this.player.template.danmakuReport.addEventListener('click', function (e) {
                    console.log('举报');
                    if (_this2.player.controller.clickFlag > 1)
                        return;
                    var videoMask = _this2.player.template.videoMask;
                    if (videoMask.classList.contains('fullscreen')) {
                        var maskDanContent = _this2.player.template.danmakuReportMask.querySelector('.danmaku-content');
                        maskDanContent.innerText = _this2.lockDanmakuData.text;
                        maskDanContent.dataset.danData = JSON.stringify(_this2.lockDanmakuData);
                        _this2.player.set.show('danmakuReport');
                    } else {
                        _this2.player.events && _this2.player.events.trigger('show_danmaku_report', _this2.lockDanmakuData);
                    }
                });
            }
        },
        {
            key: 'load',
            value: function load() {
                var _this3 = this;
                var _JSON$parse = JSON.parse(JSON.stringify(this.options.api)), address = _JSON$parse.address, danmakuAddition = _JSON$parse.danmakuAddition, id = _JSON$parse.id, otherDanParams = _JSON$parse.otherDanParams, advDanApi = _JSON$parse.advDanApi;
                var apiurl = ''.concat(address, '?id=').concat(id).concat(otherDanParams);
                this.endpoints = danmakuAddition || [];
                var advDanData = [];
                id && address && this.endpoints.push({
                    url: apiurl,
                    type: 'mfuns-danmaku',
                    origin: 'mfuns'
                });
                advDanApi && this.endpoints.push({
                    url: ''.concat(advDanApi.address, '/v1/advdanmaku?id=').concat(advDanApi.id),
                    type: 'mfuns-advDanmaku-oldApi'
                });
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this.loaded = false;
                this.endpoints.forEach(function (el) {
                    if (!el.origin) {
                        switch (el.type) {
                        case 'bili-danmaku':
                            el.origin = 'bili';
                            break;
                        case 'acfun-danmaku':
                            el.origin = 'acfun';
                            break;
                        default:
                            el.origin = 'unknown';
                        }
                    }
                });
                this._readAllEndpoints(this.endpoints, function (results, loadStatus) {
                    if (!loadStatus) {
                        console.log(loadStatus, results);
                        _this3.events && _this3.events.trigger('danmaku_load_end', []);
                        _this3.player.template.danmakuCount.innerText = 0;
                        return _this3.options.error(results);
                    } else {
                        _this3.dan = [].concat.apply([], results).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this3.dan.forEach(function (d) {
                            d.id = _this3.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this3.danCount[d.origin]++;
                        });
                        console.log(_this3.dan);
                        _this3.events && _this3.events.trigger('danmaku_load_end', _this3.dan);
                        _this3.player.template.danmakuCount.innerText = _this3.dan.length;
                        _this3.player.video.duration && _this3.watchPerformance();
                        _this3.loaded = true;
                        window.requestAnimationFrame(function () {
                            _this3.frame();
                        });
                        _this3.options.callback(_this3.dan.length, advDanData);
                    }
                });
            }
        },
        {
            key: 'reload',
            value: function reload(newId, newAdvDanApi, newAddition, newOtherDanParams) {
                if (newId) {
                    this.options.api.id = newId;
                }
                if (newOtherDanParams) {
                    this.options.api.otherDanParams = newOtherDanParams;
                }
                if (newAddition) {
                    this.options.api.danmakuAddition = newAddition;
                }
                if (newAdvDanApi) {
                    this.options.api.advDanApi = newAdvDanApi;
                }
                [
                    'mfuns',
                    'bili',
                    'acfun',
                    'unknown'
                ].forEach(function (el) {
                });
                this.dan = [];
                this.danCount = {
                    unknown: 0,
                    mfuns: 0,
                    bili: 0,
                    acfun: 0
                };
                this.danData = {
                    unknown: null,
                    mfuns: null,
                    bili: null,
                    acfun: null
                };
                this.clear();
                this.load();
            }
        },
        {
            key: 'reloadEndPoints',
            value: function reloadEndPoints(origin) {
                var _this4 = this;
                var currentEndPoints = [];
                this.endpoints.forEach(function (el) {
                    if (el.origin === origin) {
                        currentEndPoints.push(el);
                    }
                });
                console.log(currentEndPoints);
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this._readAllEndpoints(currentEndPoints, function (results, loadStatus) {
                    if (!loadStatus) {
                        console.log(loadStatus, results);
                        _this4.events && _this4.events.trigger('danmaku_load_end', []);
                        _this4.options.error(results, true);
                    } else {
                        console.log(_this4.danData);
                        var _this4$danData2 = _this4.danData, acfun = _this4$danData2.acfun, bili = _this4$danData2.bili, mfuns = _this4$danData2.mfuns, unknown = _this4$danData2.unknown;
                        _this4.dan = [].concat(_toConsumableArray(acfun !== null && acfun !== void 0 ? acfun : []), _toConsumableArray(bili !== null && bili !== void 0 ? bili : []), _toConsumableArray(mfuns !== null && mfuns !== void 0 ? mfuns : []), _toConsumableArray(unknown !== null && unknown !== void 0 ? unknown : [])).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this4.dan.forEach(function (d) {
                            d.id = _this4.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this4.danCount[d.origin]++;
                        });
                        _this4.events && _this4.events.trigger('danmaku_load_end', _this4.dan);
                        _this4.loaded = true;
                        _this4.options.callback(_this4.dan.length, null, true);
                    }
                });
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, callback) {
                var _this5 = this;
                var allRequests = endpoints.map(function (link) {
                    return new Promise(function (resolve, reject) {
                        _this5.options.apiBackend.read({
                            url: link.url,
                            type: link.type,
                            origin: link.origin,
                            success: function success(data) {
                                _this5.danData[''.concat(link.origin)] = data;
                                resolve(data);
                            },
                            error: function error(_error) {
                                reject(_error);
                            }
                        });
                    });
                });
                Promise.all(_toConsumableArray(allRequests)).then(function (res) {
                    callback(res, 1);
                })['catch'](function (err) {
                    console.log(err);
                    callback(err, 0, origin);
                });
            }
        },
        {
            key: 'send',
            value: function send(dan) {
                var _dan$size, _dan$size2, _dan$type;
                var newDanmakuId = this.createHash(8);
                var danmakuData = {
                    time: this.options.time() + 0.2,
                    size: (_dan$size = dan.size) !== null && _dan$size !== void 0 ? _dan$size : 18,
                    author: this.player.options.uid,
                    id: newDanmakuId,
                    text: dan.text,
                    color: utils.color2Number(dan.color || '#FFFFFF'),
                    type: utils.type2number(dan.type || 'right')
                };
                var danmaku = {
                    time: danmakuData.time,
                    text: this.htmlEncode(danmakuData.text),
                    color: danmakuData.color,
                    size: (_dan$size2 = dan.size) !== null && _dan$size2 !== void 0 ? _dan$size2 : 18,
                    type: (_dan$type = dan.type) !== null && _dan$type !== void 0 ? _dan$type : 'right',
                    id: newDanmakuId,
                    isSubtitle: /(\/n)|(\\n)/i.test(danmakuData.text),
                    border: '2px solid '.concat(this.options.borderColor || '#fff')
                };
                this.dan.splice(this.danIndex, 0, danmakuData);
                console.log(this.dan[0]);
                this.danIndex++;
                this.draw(danmaku);
                this.events && this.events.trigger('danmaku_send', Object.assign(_objectSpread({}, danmakuData), { size: utils.fontSizeFit('mobile2pc').get(dan.size || 18) }));
            }
        },
        {
            key: 'getDanmakuData',
            value: function getDanmakuData(id) {
                var dan;
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].id === id) {
                        dan = this.dan[i];
                        break;
                    }
                }
                return dan;
            }
        },
        {
            key: 'frame',
            value: function frame() {
                var _this6 = this;
                if (this.dan.length && !this.paused && this.showing) {
                    var item = this.dan[this.danIndex];
                    var dan = [];
                    while (item && this.options.time() > parseFloat(item.time)) {
                        if (this.checkShield(item)) {
                            dan.push(item);
                        }
                        item = this.dan[++this.danIndex];
                    }
                    if (this.colorLimit) {
                        dan = dan.filter(function (el) {
                            return el.color === 16777215;
                        });
                    }
                    if (dan.length) {
                        this.draw(dan, this.drawIndex + 1);
                        this.drawIndex++;
                    }
                }
                window.requestAnimationFrame(function () {
                    _this6.frame();
                });
            }
        },
        {
            key: 'limitArea',
            value: function limitArea(areaType) {
                if (areaType === 'keepOutSubtitle') {
                    this.keepOutSubtitle = true;
                    this.container.style.bottom = '20%';
                    return;
                } else if (areaType === 'notKeepOutSubtitle') {
                    this.keepOutSubtitle = false;
                    this.container.style.bottom = '0';
                    return;
                }
                this._limitArea = Math.min(areaType / 4, 1);
                if (areaType < 4 && !this.bottomLimit) {
                    this.player.set.danmakuFilter.pick('bottom');
                }
                this.unlimited = areaType > 4;
            }
        },
        {
            key: 'shield',
            value: function shield(type) {
                var _this7 = this;
                var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                console.log(type, flag);
                this[''.concat(type, 'Limit')] = flag;
                var items = _toConsumableArray(this.container.querySelectorAll('.mfunsPlayer-danmaku-item'));
                if (flag) {
                    this.clear(type);
                    var forbidDanmaku = this.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type));
                    forbidDanmaku.forEach(function (el) {
                        if (!el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'color' && flag) {
                    items.forEach(function (el) {
                        if (el.style.color !== 'rgb(255, 255, 255)' && !el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'repeat') {
                    var uniqueDan = [];
                    items.forEach(function (el) {
                        if (uniqueDan.includes(el.innerText) && !el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        } else {
                            uniqueDan.push(el.innerText);
                        }
                    });
                }
                if (type === 'special') {
                }
                var filterArr = [];
                var allType = [
                    'top',
                    'bottom',
                    'left',
                    'right',
                    'color',
                    'repeat',
                    'special'
                ];
                allType.forEach(function (el) {
                    if (_this7[''.concat(el, 'Limit')]) {
                        filterArr.push(el);
                    }
                });
                this.events && this.events.trigger('setDanmaku', {
                    key: 'shields',
                    value: filterArr
                });
                this.events && this.events.trigger('danmaku_filter', {
                    key: 'type',
                    value: filterArr
                });
            }
        },
        {
            key: 'opacity',
            value: function opacity(percentage) {
                if (percentage !== undefined) {
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            continue;
                        items[i].style.opacity = percentage;
                    }
                    this._opacity = percentage;
                }
                return this._opacity;
            }
        },
        {
            key: 'size',
            value: function size(scale) {
                this._fontScale = scale;
                return this._fontScale;
            }
        },
        {
            key: 'speed',
            value: function speed(_speed) {
                var speedName;
                if (_speed !== undefined) {
                    switch (_speed) {
                    case 0.5:
                        speedName = 'lowest';
                        break;
                    case 0.75:
                        speedName = 'low';
                        break;
                    case 1:
                        speedName = '';
                        break;
                    case 1.25:
                        speedName = 'fast';
                        break;
                    case 1.5:
                        speedName = 'fastest';
                        break;
                    default:
                        break;
                    }
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-move');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            return;
                        if (!!speedName) {
                            items[i].classList.add(speedName);
                        }
                        if (!!this._speed) {
                            items[i].classList.remove(this._speed);
                        }
                    }
                }
                this._speed = speedName;
                this._speedVal = _speed;
            }
        },
        {
            key: 'draw',
            value: function draw(dan, index) {
                var _this8 = this;
                if (this.showing) {
                    var itemHeight = this.options.height * this._fontScale;
                    var danWidth = this.container.offsetWidth;
                    var danHeight = this.container.offsetHeight * this._limitArea;
                    var itemY = Math.floor(danHeight / itemHeight);
                    if (this.tunnelHeights.right.length !== itemY)
                        this.tunnelHeights.right = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.left.length !== itemY)
                        this.tunnelHeights.left = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.top.length !== itemY)
                        this.tunnelHeights.top = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.bottom.length !== itemY)
                        this.tunnelHeights.bottom = utils.createArray(itemY, itemHeight);
                    var danItemRight = function danItemRight(ele, istest) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleRight = ele.getBoundingClientRect().right || _this8.container.getBoundingClientRect().right + eleWidth;
                        if (istest) {
                            console.dir(ele.offsetWidth);
                        }
                        return _this8.container.getBoundingClientRect().right - eleRight;
                    };
                    var danItemLeft = function danItemLeft(ele) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleLeft = ele.getBoundingClientRect().left || _this8.container.getBoundingClientRect().left - eleWidth;
                        return eleLeft - _this8.container.getBoundingClientRect().left;
                    };
                    var danSpeed = function danSpeed(width) {
                        var _this8$_speedVal;
                        return ((danWidth + width) / _this8.player.fullScreen.isFullScreen() ? 8 : 5) * ((_this8$_speedVal = _this8._speedVal) !== null && _this8$_speedVal !== void 0 ? _this8$_speedVal : 1);
                    };
                    var realDOMTunnel = function realDOMTunnel(type, i) {
                        var DOMTunnel = _toConsumableArray(_this8.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type))).filter(function (el) {
                            return el.dataset.tunnel === ''.concat(i);
                        });
                        return DOMTunnel;
                    };
                    var tunnelPush = {
                        right: {},
                        left: {},
                        bottom: {},
                        top: {}
                    };
                    var getTunnel = function getTunnel(ele, type, width) {
                        var tmp = danWidth / danSpeed(width);
                        var _loop2 = function _loop2(i) {
                            var item = _this8.danTunnel[type][i + ''];
                            if (item && item.length) {
                                if (type !== 'right' && type !== 'left') {
                                    return 'continue';
                                }
                                for (var j = 0; j < item.length; j++) {
                                    if (type === 'right') {
                                        var danRight = danItemRight(item[j]) - 10;
                                        _this8.tunnelHeights[type][i] = parseInt(item[j].style.fontSize) + _this8.tunnelPadding;
                                        if (danRight <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danRight <= 0) {
                                            break;
                                        }
                                    }
                                    if (type === 'left') {
                                        var danLeft = danItemLeft(item[j]) - 10;
                                        _this8.tunnelHeights[type][i] = parseInt(item[j].style.fontSize) + _this8.tunnelPadding;
                                        if (danLeft <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danLeft <= 0) {
                                            break;
                                        }
                                    }
                                    if (j === item.length - 1) {
                                        if (tunnelPush[type] && tunnelPush[type][i + ''] && !_this8.unlimited) {
                                            break;
                                        }
                                        var d = _toConsumableArray(_this8.danTunnel[type][i]);
                                        index === 1 && console.log(i, d.map(function (el) {
                                            return ele.getBoundingClientRect().left;
                                        }));
                                        _this8.danTunnel[type][i + ''].push(ele);
                                        tunnelPush[type][i + ''] = true;
                                        ele.addEventListener('animationend', function () {
                                            var _this8$danTunnel$type;
                                            var index = (_this8$danTunnel$type = _this8.danTunnel[type][i + '']) === null || _this8$danTunnel$type === void 0 ? void 0 : _this8$danTunnel$type.indexOf(ele);
                                            _this8.danTunnel[type] !== {} && _this8.danTunnel[type][i + ''].splice(index, 1);
                                        });
                                        return { v: i };
                                    }
                                }
                            } else {
                                if (tunnelPush[type] && tunnelPush[type][i + ''] && !_this8.unlimited) {
                                    return 'break';
                                }
                                if (Array.isArray(_this8.danTunnel[type][i + ''])) {
                                    _this8.danTunnel[type][i + ''].push(ele);
                                } else {
                                    _this8.danTunnel[type][i + ''] = [ele];
                                }
                                tunnelPush[type][i + ''] = true;
                                ele.addEventListener('animationend', function () {
                                    var _this8$danTunnel$type2, _this8$danTunnel$type3;
                                    var index = (_this8$danTunnel$type2 = _this8.danTunnel[type][i + '']) === null || _this8$danTunnel$type2 === void 0 ? void 0 : _this8$danTunnel$type2.indexOf(ele);
                                    _this8.danTunnel[type] !== {} && ((_this8$danTunnel$type3 = _this8.danTunnel[type][i + '']) === null || _this8$danTunnel$type3 === void 0 ? void 0 : _this8$danTunnel$type3.splice(index, 1));
                                });
                                return { v: i };
                            }
                        };
                        for (var i = 0; _this8.unlimited || i < itemY; i++) {
                            var _ret2 = _loop2(i);
                            if (_ret2 === 'continue')
                                continue;
                            if (_ret2 === 'break')
                                break;
                            if (_typeof(_ret2) === 'object')
                                return _ret2.v;
                        }
                        return -1;
                    };
                    if (Object.prototype.toString.call(dan) !== '[object Array]') {
                        dan = [dan];
                    }
                    var docFragment = document.createDocumentFragment();
                    var _loop3 = function _loop3() {
                        var _dan$i$size;
                        if (!dan[i].color) {
                            dan[i].color = 16777215;
                        }
                        if (!dan[i].size) {
                            dan[i].size = 18;
                        }
                        var item = document.createElement('div');
                        if (!_this8.paused) {
                            item.classList.add('mfunsPlayer-danmaku-run');
                        } else {
                            item.classList.remove('mfunsPlayer-danmaku-run');
                        }
                        item.classList.add('mfunsPlayer-danmaku-'.concat(dan[i].type), 'mfunsPlayer-danmaku-item');
                        dan[i].isSubtitle = /(\/n)|(\\n)/i.test(dan[i].text);
                        dan[i].isSubtitle && item.classList.add('subtitle');
                        if (dan[i].border) {
                            item.innerHTML = '<span style="border:'.concat(dan[i].border, '">').concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        } else {
                            item.innerHTML = '<span>'.concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        }
                        if (typeof dan[i].color !== 'string') {
                            item.style.color = utils.number2Color(dan[i].color);
                        } else {
                            item.style.color = dan[i].color;
                        }
                        item.style.opacity = _this8._opacity;
                        item.style.fontSize = +dan[i].size * (dan[i].isSubtitle ? 1 : _this8._fontScale) + 'px';
                        item.addEventListener('animationend', function () {
                            _toConsumableArray(_this8.container.children).includes(item) && _this8.container.removeChild(item);
                        });
                        var itemWidth = _this8._measure(dan[i].text, (_dan$i$size = +dan[i].size) !== null && _dan$i$size !== void 0 ? _dan$i$size : 18);
                        var tunnel, realTunnel;
                        switch (dan[i].type) {
                        case 'right':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth, dan[i].id);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var maxTop = _this8.tunnelHeights.right.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var top = _this8.tunnelHeights.right.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % maxTop;
                                if (top + parseInt(item.style.fontSize) + _this8.tunnelPadding > danHeight) {
                                    var _this8$danTunnel$dan$;
                                    (_this8$danTunnel$dan$ = _this8.danTunnel[dan[i].type][tunnel]) === null || _this8$danTunnel$dan$ === void 0 ? void 0 : _this8$danTunnel$dan$.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : top) + 'px';
                                item.style.transform = 'translateX(-'.concat(danWidth, 'px)');
                            }
                            break;
                        case 'left':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var _maxTop = _this8.tunnelHeights.left.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var _top = _this8.tunnelHeights.left.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % _maxTop;
                                if (_top + parseInt(item.style.fontSize) + _this8.tunnelPadding > danHeight) {
                                    var _this8$danTunnel$dan$2;
                                    (_this8$danTunnel$dan$2 = _this8.danTunnel[dan[i].type][i + '']) === null || _this8$danTunnel$dan$2 === void 0 ? void 0 : _this8$danTunnel$dan$2.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : _top) + 'px';
                                item.style.transform = 'translateX('.concat(danWidth, 'px)');
                            }
                            break;
                        case 'top':
                            if (_this8.miniMode)
                                return { v: void 0 };
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var topArr = [];
                                var topDan = _this8.danTunnel.top;
                                for (var key in topDan) {
                                    topArr.push.apply(topArr, _toConsumableArray(topDan[key]));
                                }
                                var _top2 = topArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this8.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (_top2 + parseInt(item.style.fontSize) + _this8.tunnelPadding > danHeight) {
                                    var _this8$danTunnel$dan$3;
                                    (_this8$danTunnel$dan$3 = _this8.danTunnel[dan[i].type][i + '']) === null || _this8$danTunnel$dan$3 === void 0 ? void 0 : _this8$danTunnel$dan$3.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.top = (dan[i].isSubtitle ? 0 : _top2) + 'px';
                            }
                            break;
                        case 'bottom':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var bottomArr = [];
                                var bottomDan = _this8.danTunnel.bottom;
                                for (var _key2 in bottomDan) {
                                    bottomArr.push.apply(bottomArr, _toConsumableArray(bottomDan[_key2]));
                                }
                                var bottom = bottomArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this8.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (bottom + parseInt(item.style.fontSize) + _this8.tunnelPadding > danHeight) {
                                    var _this8$danTunnel$dan$4;
                                    (_this8$danTunnel$dan$4 = _this8.danTunnel[dan[i].type][i + '']) === null || _this8$danTunnel$dan$4 === void 0 ? void 0 : _this8$danTunnel$dan$4.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.bottom = (dan[i].isSubtitle ? 0 : bottom) + 'px';
                            }
                            break;
                        default:
                            console.error('无法处理的弹幕: ', dan[i]);
                        }
                        if (tunnel >= 0) {
                            item.classList.add('mfunsPlayer-danmaku-move');
                            item.dataset.id = dan[i].id;
                            if (!!_this8._speed && !dan[i].isSubtitle) {
                                item.classList.add(_this8._speed);
                            }
                            docFragment.appendChild(item);
                        }
                    };
                    for (var i = 0; i < dan.length; i++) {
                        var _ret3 = _loop3();
                        if (_ret3 === 'continue')
                            continue;
                        if (_typeof(_ret3) === 'object')
                            return _ret3.v;
                    }
                    this.container.appendChild(docFragment);
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
            }
        },
        {
            key: '_measure',
            value: function _measure(text, size) {
                var _measureStyle$getProp;
                if (!this.demoDanmaku) {
                    this.demoDanmaku = this.container.getElementsByClassName('mfunsPlayer-danmaku-item')[0];
                }
                this.demoDanmaku.style.fontSize = size * this._fontScale + 'px';
                var measureStyle = getComputedStyle(this.demoDanmaku, null);
                if (!this.context) {
                    this.context = document.createElement('canvas').getContext('2d');
                }
                var fontSize = measureStyle.getPropertyValue('font-size');
                var fontWeight = measureStyle.getPropertyValue('font-weight');
                var fontFamily = measureStyle.getPropertyValue('font-family');
                this.context.font = (_measureStyle$getProp = measureStyle.getPropertyValue('font')) !== null && _measureStyle$getProp !== void 0 ? _measureStyle$getProp : ''.concat(fontWeight, '  ').concat(fontSize, ' / ').concat(fontSize, ' ').concat(fontFamily);
                return this.context.measureText(text).width;
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.clear();
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].time >= this.options.time()) {
                        this.danIndex = i;
                        break;
                    }
                    this.danIndex = this.dan.length;
                }
            }
        },
        {
            key: 'clear',
            value: function clear(type) {
                if (type) {
                    this.danTunnel[type] = {};
                    return;
                }
                this.danTunnel = {
                    right: {},
                    left: {},
                    top: {},
                    bottom: {}
                };
                this.danIndex = 0;
                this.currentDan = [];
                this.options.container.innerHTML = '';
                this.options.container.appendChild(this.demoDanmaku);
                this.events && this.events.trigger('danmaku_clear');
            }
        },
        {
            key: 'htmlEncode',
            value: function htmlEncode(str) {
                return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
            }
        },
        {
            key: 'resize',
            value: function resize() {
                var danWidth = this.container.offsetWidth;
                var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.transform = 'translateX(-'.concat(danWidth, 'px)');
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.showing = false;
                this.pause();
                this.clear();
                this.player.template.danmakuButton.classList.add('close');
                this.player.template.danmakuButton.classList.remove('open');
                this.player.template.danmakuSet.style.display = 'none';
                this.player.template.input.classList.add('nodanmaku');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'showDanmaku',
                    value: false
                });
            }
        },
        {
            key: 'show',
            value: function show() {
                this.seek();
                this.showing = true;
                this.play();
                this.player.template.danmakuButton.classList.add('open');
                this.player.template.danmakuButton.classList.remove('close');
                this.player.template.danmakuSet.style.display = 'block';
                this.player.template.input.classList.remove('nodanmaku');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'showDanmaku',
                    value: true
                });
            }
        },
        {
            key: 'unlimit',
            value: function unlimit(_boolean) {
                this.unlimited = _boolean;
            }
        },
        {
            key: 'watchPerformance',
            value: function watchPerformance() {
                var _this9 = this;
                console.log(this.player.video.duration);
                var slice = this.player.video.duration.toFixed(0);
                var Xdata = utils.createArray(slice).map(function (el, index) {
                    return index + '';
                });
                var Ydata = utils.createArray(slice).map(function () {
                    return 0;
                });
                var danSlice = 1;
                Xdata.forEach(function (el, index) {
                    _this9.dan.forEach(function (dan) {
                        if (index * danSlice <= +dan.time && +dan.time < (index + 1) * danSlice) {
                            Ydata[index]++;
                        }
                    });
                });
                var max = Math.max.apply(Math, _toConsumableArray(Ydata));
                var min = Math.min.apply(Math, _toConsumableArray(Ydata));
                console.log(Ydata);
                console.log('单位弹幕量极值分别为\uFF1A', max, min);
            }
        }
    ]);
    return Danmaku;
}();
export default Danmaku;